export const styles = {
  formWrap: {
    borderBottom: '1px solid #d9d9d9',
    backgroundColor: '#fff',
  },
}
